import { render, staticRenderFns } from "./ReportNumberplate.vue?vue&type=template&id=4a80b53c&scoped=true"
import script from "./ReportNumberplate.vue?vue&type=script&lang=ts"
export * from "./ReportNumberplate.vue?vue&type=script&lang=ts"
import style0 from "./ReportNumberplate.vue?vue&type=style&index=0&id=4a80b53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a80b53c",
  null
  
)

export default component.exports